// Vendors
import React from 'react';
// Components
import { LoadingComponent } from 'components/loading/loading.component';
// Configurations
import { getIframeLoaderCompletedProps } from './configurations/iframe.configurations';
// Constants
import { IFRAME_LOADING_COMPONENT_PROPS, IFRAME_PROPS } from './constants/iframe.constants';
// Hooks
import { useIframeHook } from 'components/iframe/hooks/iframe.hook';
// Styles
import {
  IframeComponentStyled,
  IframeLoadingComponentStyled,
  IframeLoaderComponentStyled,
} from './iframe.component.styled';
// Types
import { IframeComponentType } from './types/iframe.component.type';

const IframeComponent = ({
  frameGap,
  height,
  src,
  showLoader = false,
  ...props
}: IframeComponentType): React.JSX.Element | null => {
  const {
    fetching,
    handleCheckFrameComponentLoadSuccessEvent: onLoad,
    handleCatchAndManageFrameComponentErrorEvent: onError,
    iframeKey,
  } = useIframeHook(props);

  return src ? (
    <IframeLoadingComponentStyled {...{ fetching: fetching || showLoader }}>
      <IframeLoaderComponentStyled {...{ fetching: fetching || showLoader }}>
        <LoadingComponent
          {...{
            ...IFRAME_LOADING_COMPONENT_PROPS,
            ...getIframeLoaderCompletedProps(showLoader),
            fetching: fetching || showLoader,
          }}
        >
          <div />
        </LoadingComponent>
      </IframeLoaderComponentStyled>
      <IframeComponentStyled
        {...{
          ...IFRAME_PROPS,
          fetching: fetching || showLoader,
          frameGap,
          height,
          onError,
          onLoad,
          src,
        }}
        key={iframeKey}
      />
    </IframeLoadingComponentStyled>
  ) : null;
};

export { IframeComponent };
